// File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import { styled, keyframes } from '@compiled/react';

import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { layers } from '@atlaskit/theme/constants';
import { N0, P200, P400, P500 } from '@atlaskit/theme/colors';

import BannerVector from '../assets/BannerVector.svg';

type BannerType = {
	isContentCreationPanelOpen: boolean;
	fade: boolean;
};

export const templateSidebarWidth = 320;

const shrinkUp = keyframes({
	'0%': {
		transform: 'translateY(0)',
	},
	'100%': {
		transform: 'translateY(-100%)',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateBannerContainer = styled.div<BannerType>(
	{
		display: 'flex',
		height: '174px',
		background: `${token('color.background.accent.purple.subtler', '#DFD8FD')}`,
		position: 'absolute',
		left: 0,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		right: `${({ isContentCreationPanelOpen }) =>
			isContentCreationPanelOpen ? `${templateSidebarWidth}px` : 0}`,
		zIndex: layers.card(),
		borderBottom: `1px solid ${token('color.background.accent.gray.subtler', '#DCDFE4')}`,
		'@media (max-width: 375px)': {
			height: '300px',
		},
		'@media (max-width: 1024px)': {
			flexDirection: 'column-reverse',
			height: '291px',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		[`@media (max-width: ${1024 + templateSidebarWidth}px)`]: {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
			flexDirection: `${({ isContentCreationPanelOpen }) =>
				isContentCreationPanelOpen && 'column-reverse'}`,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
			height: `${({ isContentCreationPanelOpen }) => isContentCreationPanelOpen && '291px'}`,
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ fade }) =>
		fade && {
			animation: `${shrinkUp} 450ms ease-in-out`,
		},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledButton = styled(Button)({
	// requires the specificity and the button base includes !important :(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		background: token('color.background.discovery.bold', P400),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
		color: `${token('color.text.inverse', N0)} !important`,
		width: '110px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover': {
		background: `${token('color.background.discovery.bold.hovered', P200)}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
		color: `${token('color.text.inverse', N0)} !important`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:active': {
		background: `${token('color.background.discovery.bold.pressed', P500)}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
		color: `${token('color.text.inverse', N0)} !important`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LeftWrapper = styled.div({
	position: 'relative',
	height: '100%',
	display: 'flex',
	flex: 1,
	justifyContent: 'center',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Background = styled.div<{ isContentCreationPanelOpen: boolean }>({
	position: 'absolute',
	height: '100%',
	zIndex: -1,
	backgroundRepeat: 'no-repeat',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundImage: `url(${BannerVector})`,
	width: '100%',
	backgroundPosition: '100% 60%',
	backgroundSize: '95% 200%',
	'@media (max-width: 1024px)': {
		backgroundPosition: '100% 0%',
		backgroundSize: '100% 200%',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${1024 + templateSidebarWidth}px)`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundPosition: `${({ isContentCreationPanelOpen }) =>
			isContentCreationPanelOpen && '100% 0%'}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundSize: `${({ isContentCreationPanelOpen }) =>
			isContentCreationPanelOpen && '100% 200%'}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RightWrapper = styled.div<{ isContentCreationPanelOpen: boolean }>({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	flex: 1,
	paddingTop: token('space.300', '24px'),
	'@media (max-width: 1024px)': {
		paddingLeft: token('space.300', '24px'),
		paddingTop: token('space.300', '24px'),
		flex: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${1024 + templateSidebarWidth}px)`]: {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		paddingLeft: `${({ isContentCreationPanelOpen }) => isContentCreationPanelOpen && '24px'}`,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		paddingTop: `${({ isContentCreationPanelOpen }) => isContentCreationPanelOpen && '24px'}`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		flex: `${({ isContentCreationPanelOpen }) => isContentCreationPanelOpen && 'none'}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleWrapper = styled.span({
	fontWeight: 500,
	fontSize: token('space.250'),
	lineHeight: '24px',
	color: `${token('color.text', '#172B4D')}`,
	marginBottom: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyWrapper = styled.span<{ isContentCreationPanelOpen: boolean }>({
	fontWeight: 400,
	fontSize: token('space.150'),
	lineHeight: '20px',
	color: `${token('color.text', '#172B4D')}`,
	marginBottom: token('space.200', '16px'),
	width: '100%',
	overflowWrap: 'break-word',
	wordWrap: 'break-word',
	maxWidth: '427px',
	'@media (max-width: 1024px)': {
		maxWidth: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${1024 + templateSidebarWidth}px)`]: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		maxWidth: `${({ isContentCreationPanelOpen }) => isContentCreationPanelOpen && 'none'}`,
	},
});
